import { type Module } from "~/foundation/Bootstrapper/types";
import { openDownload, resolveDownloadUrl } from "~/foundation/Helpers/appDownload";
import { isApp } from "~/foundation/Helpers/isApp";
import { isExperienceEditor } from "~/foundation/Helpers/isExperienceEditor";

function isModifiedClick(event: MouseEvent): boolean {
	return (
		event.metaKey ||
		event.ctrlKey ||
		event.shiftKey ||
		event.altKey ||
		event.button !== 0
	);
}

function isSafeDownloadUrl(url: string): boolean {
	return (
		!url.startsWith("#") && !url.toLowerCase().startsWith("javascript:")
	);
}

function handleDownload(url: string, event: MouseEvent): void {
	if (isModifiedClick(event)) {
		return;
	}

	if (!resolveDownloadUrl(url)) {
		return;
	}

	event.preventDefault();
	openDownload(url);
}

export const wallpaperDownload: Module = (container) => {
	if (isExperienceEditor) {
		return;
	}

	container
		.querySelectorAll<HTMLButtonElement>(
			'button[type="button"][data-wallpaper-url]'
		)
		.forEach((button) => {
			const url = button.dataset.wallpaperUrl;

			if (!url || !isSafeDownloadUrl(url)) {
				return;
			}

			button.addEventListener("click", (event) => handleDownload(url, event));
		});

	if (!isApp()) {
		return;
	}

	container
		.querySelectorAll<HTMLAnchorElement>(
			".section-sub-nav__item a[download][href]"
		)
		.forEach((anchor) => {
			const url = anchor.getAttribute("href");

			if (!url || !isSafeDownloadUrl(url)) {
				return;
			}

			anchor.addEventListener("click", (event) => handleDownload(url, event));
		});
};

export default wallpaperDownload;
